<template src="./component.html"></template>

<script>
// import {validateInn} from '@/functions/validate';
import axios from 'axios';

export default {
  name: "ModalForm",
  data() {
    return {
      agreeForm: false,
      agreeText: 'Я даю <a href="https://static.ofd.ru/ofdru/politic/consent_pd.pdf" target="_blank">согласие</a> на обработку моих персональных данных в&nbsp;соответствии с&nbsp;<a href="https://static.ofd.ru/ofdru/politic/privacy_policy.pdf" target="_blank">Политикой конфиденциальности</a>.',
      form: {
        Name: '',
        Phone: '',
        Email: '',
      },

      step: 1,
      // step: 'error',

      rules: {
        required: value => !!value || 'Обязательное поле',
        // eslint-disable-next-line
        email: value => /^[0-9a-z-_а-яА-ЯёЁ\.]+\@[0-9a-z-а-яА-ЯёЁ]{2,}\.[a-zа-яА-ЯёЁ]{2,}/i.test(value) || 'Неверный формат E-Mail',
        phone: value => /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(value) || 'Неверный формат телефона',
        phoneMin17: value => value.length === 17 || 'Неверный формат телефона',
        // inn: value => {
        //   const validateInnResult = validateInn(value, {});
        //   return validateInnResult || 'Введён не верный ИНН';
        // },
      },
    }
  },
  methods: {
    onForm: function (e) {
      e.preventDefault();

      if (this.$refs['form-order'].validate()) {
        axios
          .post('/api/renta/landing/store', {
            FIO: this.form.Name,
            Email: this.form.Email,
            Phone: this.form.Phone,
          })
          .then(() => {
            this.step = 'true';

          })
          .catch(() => {
            this.step = 'error';
          });
      }
    },
    hide() {
      this.$modal.hide('form-modal-contact');
      this.ressetForm();
    },
    ressetForm() {
      this.step = 1;
      this.form.Name = '';
      this.form.Email = '';
      this.form.Phone = '';

    },
    beforeOpen (event) {
      if (event.params) {
        this.step = event.params.step;
      }
    }
  }
}
</script>

<style src="./component.scss" scoped lang="scss"/>

